import styled from 'styled-components';

export const PocketStyle = styled.div`
    margin-inline: 20px;
    padding-block: 75px;
`